/*
 * CBS - Free shipping progress bar
 * Keeps every <free-shipping-bar> on the page in sync with the cart.
 * Listens for theme cart events and watches /cart/add|change|update|clear
 * requests (fetch + XHR) so it also updates when apps change the cart.
 */
(function () {
  if (window.CBSFreeShippingBar) return;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var refreshTimer = null;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return match ? format.replace(match[0], value) : value;
  }

  function currencyRate() {
    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return rate && rate > 0 ? rate : 1;
  }

  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.update({ total_price: parseInt(this.dataset.cartTotal, 10) || 0, item_count: this.hidden ? 0 : 1 }, true);
    }

    get thresholdCents() {
      // Threshold is set in the store's base currency; convert for other presentment currencies.
      var base = parseInt(this.dataset.threshold, 10) || 0;
      return Math.round(base * currencyRate());
    }

    update(cart, initial) {
      var threshold = this.thresholdCents;
      var total = parseInt(cart.total_price, 10) || 0;
      var remaining = Math.max(threshold - total, 0);
      var percent = threshold > 0 ? Math.min((total / threshold) * 100, 100) : 100;
      var unlocked = remaining === 0;

      if (!initial && this.dataset.hideEmpty === 'true') {
        this.hidden = cart.item_count === 0;
      }

      this.classList.toggle('is-unlocked', unlocked);

      var fill = this.querySelector('[data-fsb-fill]');
      var track = this.querySelector('[data-fsb-track]');
      if (fill) fill.style.width = percent.toFixed(2) + '%';
      if (track) track.setAttribute('aria-valuenow', Math.round(percent));

      var message = this.querySelector('[data-fsb-message]');
      if (!message) return;
      message.textContent = '';
      if (unlocked) {
        message.textContent = this.dataset.successText || '';
        return;
      }
      var parts = (this.dataset.progressText || '').split('[amount]');
      parts.forEach(function (part, i) {
        if (i > 0) {
          var strong = document.createElement('strong');
          strong.setAttribute('data-fsb-amount', '');
          strong.textContent = formatMoney(remaining, this.dataset.moneyFormat);
          message.appendChild(strong);
        }
        message.appendChild(document.createTextNode(part));
      }, this);
    }
  }

  function updateAll(cart) {
    if (!cart || typeof cart.total_price === 'undefined') return;
    document.querySelectorAll('free-shipping-bar').forEach(function (bar) {
      bar.update(cart);
    });
  }

  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(updateAll)
        .catch(function () {});
    }, 150);
  }

  function isCartMutation(url) {
    try {
      var path = new URL(url, window.location.origin).pathname;
      return CART_MUTATION.test(path);
    } catch (e) {
      return false;
    }
  }

  // Watch fetch requests that change the cart
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var request = originalFetch.apply(this, arguments);
      if (isCartMutation(url)) {
        request.then(refresh, function () {});
      }
      return request;
    };
  }

  // Watch XHR requests that change the cart (jQuery / app scripts)
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) {
      this.addEventListener('loadend', refresh);
    }
    return originalOpen.apply(this, arguments);
  };

  // Theme / app cart events
  ['cart:updated', 'cart:refresh', 'ajaxProduct:added', 'cart:open'].forEach(function (name) {
    document.addEventListener(name, function (evt) {
      if (evt.detail && evt.detail.cart && typeof evt.detail.cart.total_price !== 'undefined') {
        updateAll(evt.detail.cart);
      } else {
        refresh();
      }
    });
  });

  // Back/forward cache restores can show a stale cart
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) refresh();
  });

  if (!customElements.get('free-shipping-bar')) {
    customElements.define('free-shipping-bar', FreeShippingBar);
  }

  window.CBSFreeShippingBar = { refresh: refresh, update: updateAll, formatMoney: formatMoney };
})();
